import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Grid, Chip, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import moment from 'moment';
import 'moment/locale/hu';
import i18n from '../../i18n.js';
import { useMutation, useQueryClient } from 'react-query';

import Comments from './Comments/Comments';
import { addAlert } from '../../actions/alerts.action';
import { approveManagerialDecision } from '../../api/managerialDecision/managerialDecision.api';

const ManagerialDecisionItem  = ({ managerialDecision, managerialDecisionsQuery }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  moment.locale('hu');
  const lng = i18n.languages[0];
  const {
    id,
    title,
    created_at,
    creator_name,
    updated_by,
    updated_at,
    category,
    description,
    approved_at
  } = managerialDecision;

  const createFormattedDate = date => (
    `${moment(date).format('L')}, ${moment(date).format('LT')}`
  );

  const createDateString = (action, action_by, action_date) => {
    const actionByString = `: ${action_by} `;

    return `
      ${t('managerialDecisions.date.' + action)}${action !== 'approved' ? actionByString : ' '}|
      ${t('managerialDecisions.date.date')}: ${createFormattedDate(action_date)}
    `;
  };

  const approveManagerialDecisionMutation = useMutation(
    async () => {
      return await approveManagerialDecision(id);
    },
    {
      onSuccess: () => {
        managerialDecisionsQuery.refetch();
        queryClient.invalidateQueries('drawerInfo');
      },
      onError: error => {
        dispatch(addAlert({ message: error.message, severity: 'error' }));
      }
    }
  );

  const approve = () => {
    approveManagerialDecisionMutation.mutate();
  };

  const useStyles = makeStyles({
    wrapper: {
      background: '#F4F4F4',
      marginBottom: '15px',
      padding: '20px',
      borderRadius: '4px',
      color: '#000000DA'
    },
    title: {
      fontWeight: '350px',
      fontSize: '17px'
    },
    chip: {
      fontSize: '13px'
    },
    description: {
      marginLeft: '10px',
      whiteSpace: 'pre-wrap'
    },
    grey: {
      color: 'grey'
    },
    dates: {
      fontSize: '14px'
    }
  });

  const classes = useStyles();

  return (
    <div className={ classes.wrapper }>
      <Grid container spacing={ 2 } direction="column">
        <Grid container item direction="row" justifyContent="space-between" alignItems="center">
          <Grid item className={ classes.title }>{ title }</Grid>
          <Grid item className={ classes.dates }>
            <div className={ updated_at && updated_by ? classes.grey : '' }>
              { createDateString('created', creator_name, created_at) }
            </div>
            { updated_at && updated_by &&
              <div>{ createDateString('updated', updated_by, new Date(Number(updated_at))) }</div>
            }
            { approved_at &&
              <div>{ createDateString('approved', '', approved_at) }</div>
            }
          </Grid>
        </Grid>
        { category &&
          <Grid item>
            <Chip className={ classes.chip } label={ category?.category_name?.[lng] } />
          </Grid>
        }
        { description &&
          <Grid item className={ classes.description }>
            { description }
          </Grid>
        }
        <Grid item>
          <Button
            onClick={ approve }
            disabled={ approved_at }
            color="secondary"
            variant="contained"
          >
            { approved_at ?
              t('managerialDecisions.approved') :
              t('managerialDecisions.notApproved')
            }
          </Button>
        </Grid>
        <Grid item>
          <Comments managerialDecisionId={ id }/>
        </Grid>
      </Grid>
    </div>
  );
};

export default ManagerialDecisionItem;